import { AnalystChartSpec, AnalystTableSpec } from '@digital-twins/shared-types'

import { ThreadFeaturedExhibits } from './ThreadFeaturedExhibits'

interface FindingServerSpecPlotProps {
  charts: Array<AnalystChartSpec>
  tables: Array<AnalystTableSpec>
  hasParityMismatch?: boolean
}

/**
 * Default finding exhibit through Step 7's adapter. Does not fork the
 * routing table — FeaturedAnalystChart / FeaturedAnalystTable own shape
 * decisions via routeAnalystChart / routeAnalystTable.
 */
export function FindingServerSpecPlot(props: FindingServerSpecPlotProps) {
  const { charts, tables, hasParityMismatch = false } = props

  return (
    <div data-testid="finding-server-spec-plot">
      {hasParityMismatch ? (
        <div data-testid="finding-plot-parity-mismatch" hidden />
      ) : null}
      <ThreadFeaturedExhibits charts={charts} tables={tables} />
    </div>
  )
}
